import React from "react";
import Footer from "../../components/Footer";
import SMediaServices from '../../components/SMediaServices/SMediaServices';
const sMediaServices = () => {

  return (
    <>
      {/* Footer Section  */}
      <section>
        <SMediaServices />
      </section>

      {/* Footer Section  */}
      <section>
        <Footer />
      </section>
    </>
  );
};

export default sMediaServices;